import { Orders } from "../modules/orders";

export const OrdersPage = () => {
  return <Orders />;
};
